"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.relatedRegionClickSender = exports.relatedKeywordClickSender = exports.rkRelatedKeywordClickSender = exports.regionKeywordClickSender = exports.searchClickSender = exports.querySender = exports.recomClickSender = exports.recomDetailSender = exports.recomSender = exports.autocpSender = exports.ip = void 0;
const uuid_random_1 = __importDefault(require("uuid-random"));
const dateFormat_1 = require("../../utils/dateFormat");
const axios_1 = __importDefault(require("axios"));
const gpsStorageCtrl_1 = require("../gpsStorageCtrl");
const js_cookie_1 = __importDefault(require("js-cookie"));
const logFn_1 = require("./logFn");
const getUserVuid_1 = __importDefault(require("../getUserVuid"));
const fromLogSelector_1 = require("./fromLog/fromLogSelector");
const urlParser_1 = require("../../utils/urlParser");
const getIp_1 = require("./getIp");
const logAPI = "https://4br0wfjypd.execute-api.ap-northeast-2.amazonaws.com/dc/dclog/putrecord";
const userAgent = window.navigator.userAgent;
exports.ip = "";
let cookieId = "";
// TODO : 이쪽 코드로 이사오게 된다면, ip 처리 관련해서 다 바꿔줘야함
(() => {
    localStorage.removeItem("userIP");
    (0, getIp_1.getIPAwait)(exports.ip);
    const temp_cid = js_cookie_1.default.get("dcadid");
    if (temp_cid) {
        cookieId = temp_cid;
    }
    else {
        const time = Math.floor(new Date().getTime() / 1000);
        const newCid = "M" + (0, logFn_1.getRandomAlpha)() + time.toString();
        js_cookie_1.default.set("dcadid", newCid, { expires: 60 * 60 * 24 * 400 });
        cookieId = newCid;
    }
})();
const autocpSender = async ({ user, device, logType, inputQuery, v_rid, typeSub, }) => {
    try {
        const { lat, lng } = (0, gpsStorageCtrl_1.getGpsCookie)();
        const getUserIp = sessionStorage.getItem("userIP");
        if (getUserIp) {
            exports.ip = getUserIp;
        }
        const payload = {
            Data: {
                ip: exports.ip,
                log_type: logType,
                log_type_sub: typeSub ? typeSub : "rest",
                user_agent: userAgent,
                log_id: `${(0, uuid_random_1.default)()}-${(0, logFn_1.getRandomInt)(100000, 1000000)}`,
                cookie_id: (0, logFn_1.getTotalCookieId)(cookieId),
                device: device,
                enter_date: (0, dateFormat_1.getFullTime)(),
                query: inputQuery,
                v_rid: v_rid,
                v_uid: (0, getUserVuid_1.default)(user),
                lat: lat,
                lng: lng,
            },
            PartitionKey: logType,
        };
        // 이전에 보낸 로그
        const formerDataStr = localStorage.getItem("dclogformer");
        if (formerDataStr) {
            const formerData = JSON.parse(formerDataStr);
            payload.Data.from_log_id = formerData.log_id;
            payload.Data.from_log_type = formerData.log_type;
            payload.Data.from_enter_date = formerData.enter_date;
        }
        // localStorage.setItem("dclogformer", JSON.stringify(payload.Data));
        if (exports.ip) {
            try {
                await axios_1.default.put(logAPI, payload);
            }
            catch (err) {
                console.error(err);
            }
        }
        if (!exports.ip) {
            try {
                const ipString = await (0, getIp_1.getIPAwait)(exports.ip);
                if (ipString) {
                    payload.Data.ip = ipString;
                    sessionStorage.setItem("userIP", ipString);
                    await axios_1.default.put(logAPI, payload);
                }
            }
            catch (err) {
                console.error(err);
            }
        }
    }
    catch (e) {
        console.error(e, "log error");
    }
};
exports.autocpSender = autocpSender;
const recomSender = async ({ user, device, logType, recom_json, recom_target_region, referer, test, }) => {
    try {
        const { lat, lng } = (0, gpsStorageCtrl_1.getGpsCookie)();
        const getUserIp = sessionStorage.getItem("userIP");
        if (getUserIp) {
            exports.ip = getUserIp;
        }
        const convRecom_json = JSON.stringify(recom_json);
        const payload = {
            Data: {
                ip: exports.ip,
                log_type: test ? "recom3" : logType,
                user_agent: userAgent,
                log_id: `${(0, uuid_random_1.default)()}-${(0, logFn_1.getRandomInt)(100000, 1000000)}`,
                cookie_id: (0, logFn_1.getTotalCookieId)(cookieId),
                device: device,
                enter_date: (0, dateFormat_1.getFullTime)(),
                recom_json: convRecom_json,
                recom_target_region: recom_target_region,
                v_uid: (0, getUserVuid_1.default)(user),
                lat: lat,
                lng: lng,
            },
            PartitionKey: test ? "recom3" : logType,
        };
        if (referer) {
            payload.Data = { ...payload.Data, referer };
        }
        // 이전에 보낸 로그
        (0, fromLogSelector_1.fromBeforeSelector)("recom", payload);
        if ((0, urlParser_1.isUrlIncludes)("st")) {
            console.log(payload, "logData, st- 에서 출력", "");
        }
        if (exports.ip) {
            try {
                await axios_1.default.put(logAPI, payload);
            }
            catch (err) {
                console.error(err);
            }
        }
        if (!exports.ip) {
            try {
                const ipString = await (0, getIp_1.getIPAwait)(exports.ip);
                if (ipString) {
                    payload.Data.ip = ipString;
                    sessionStorage.setItem("userIP", ipString);
                    await axios_1.default.put(logAPI, payload);
                }
            }
            catch (err) {
                console.error(err);
            }
        }
    }
    catch (e) {
        console.error(e, "log error");
    }
};
exports.recomSender = recomSender;
const recomDetailSender = async ({ user, device, logType, recom_detail_json, recom_target_region, from, test, }) => {
    const { lat, lng } = (0, gpsStorageCtrl_1.getGpsCookie)();
    const getUserIp = sessionStorage.getItem("userIP");
    if (getUserIp) {
        exports.ip = getUserIp;
    }
    const convRecomDetailJson = JSON.stringify(recom_detail_json);
    const payload = {
        Data: {
            ip: exports.ip,
            log_type: test ? "recom_detail2" : logType,
            user_agent: userAgent,
            log_id: `${(0, uuid_random_1.default)()}-${(0, logFn_1.getRandomInt)(100000, 1000000)}`,
            cookie_id: (0, logFn_1.getTotalCookieId)(cookieId),
            device: device,
            enter_date: (0, dateFormat_1.getFullTime)(),
            recom_detail_json: convRecomDetailJson,
            recom_target_region: recom_target_region,
            v_uid: (0, getUserVuid_1.default)(user),
            lat: lat,
            lng: lng,
        },
        PartitionKey: test ? "recom_detail2" : logType,
    };
    (0, fromLogSelector_1.fromRecomDetailSelector)(from, payload);
    if ((0, urlParser_1.isUrlIncludes)("st")) {
        console?.log(payload, "detail log");
    }
    if (exports.ip) {
        try {
            await axios_1.default.put(logAPI, payload);
        }
        catch (err) {
            console.error(err);
        }
    }
    if (!exports.ip) {
        try {
            const ipString = await (0, getIp_1.getIPAwait)(exports.ip);
            if (ipString) {
                payload.Data.ip = ipString;
                sessionStorage.setItem("userIP", ipString);
                await axios_1.default.put(logAPI, payload);
            }
        }
        catch (err) {
            console.error(err);
        }
    }
};
exports.recomDetailSender = recomDetailSender;
const recomClickSender = async ({ user, device, logType, recom_click_json, from, test, }) => {
    try {
        const { lat, lng } = (0, gpsStorageCtrl_1.getGpsCookie)();
        const getUserIp = sessionStorage.getItem("userIP");
        if (getUserIp) {
            exports.ip = getUserIp;
        }
        const convRecomClickJson = JSON.stringify(recom_click_json);
        const payload = {
            Data: {
                ip: exports.ip,
                log_type: test ? "recom_click3" : logType,
                user_agent: userAgent,
                log_id: `${(0, uuid_random_1.default)()}-${(0, logFn_1.getRandomInt)(100000, 1000000)}`,
                cookie_id: (0, logFn_1.getTotalCookieId)(cookieId),
                device: device,
                enter_date: (0, dateFormat_1.getFullTime)(),
                recom_click_json: convRecomClickJson,
                v_uid: (0, getUserVuid_1.default)(user),
                lat: lat,
                lng: lng,
            },
            PartitionKey: test ? "recom_click3" : logType,
        };
        // 이전에 보낸 로그
        (0, fromLogSelector_1.fromRecomClickSelector)(from, payload);
        if (exports.ip) {
            try {
                await axios_1.default.put(logAPI, payload);
            }
            catch (err) {
                console.error(err);
            }
        }
        if (!exports.ip) {
            try {
                const ipString = await (0, getIp_1.getIPAwait)(exports.ip);
                if (ipString) {
                    payload.Data.ip = ipString;
                    sessionStorage.setItem("userIP", ipString);
                    await axios_1.default.put(logAPI, payload);
                }
            }
            catch (err) {
                console.error(err);
            }
        }
    }
    catch (e) {
        console.error(e, "log error");
    }
};
exports.recomClickSender = recomClickSender;
const querySender = async ({ user, device, logType, query_json, referer, search_rn_result, test, }) => {
    try {
        const { lat, lng } = (0, gpsStorageCtrl_1.getGpsCookie)();
        const getUserIp = sessionStorage.getItem("userIP");
        if (getUserIp) {
            exports.ip = getUserIp;
        }
        const payload = {
            Data: {
                log_type: test ? "search2" : logType,
                cookie_id: (0, logFn_1.getTotalCookieId)(cookieId),
                log_id: `${(0, uuid_random_1.default)()}-${(0, logFn_1.getRandomInt)(100000, 1000000)}`,
                ip: exports.ip,
                user_agent: userAgent,
                device: device,
                enter_date: (0, dateFormat_1.getFullTime)(),
                v_uid: (0, getUserVuid_1.default)(user) ? (0, getUserVuid_1.default)(user) : query_json.v_uid,
                lat: lat,
                lng: lng,
                r_count: query_json.r_count,
                query_json: JSON.stringify({ ...query_json, r_count: undefined }),
            },
            PartitionKey: test ? "search2" : logType,
        };
        // 추가적인 search_rn_result 처리
        if (search_rn_result) {
            payload.Data = { ...payload.Data, ...search_rn_result };
        }
        if (referer) {
            payload.Data = { ...payload.Data, referer };
        }
        (0, fromLogSelector_1.fromBeforeSelector)(logType, payload);
        if (exports.ip) {
            try {
                await axios_1.default.put(logAPI, payload);
            }
            catch (err) {
                console.error(err);
            }
        }
        if (!exports.ip) {
            try {
                const ipString = await (0, getIp_1.getIPAwait)(exports.ip);
                if (ipString) {
                    payload.Data.ip = ipString;
                    sessionStorage.setItem("userIP", ipString);
                    await axios_1.default.put(logAPI, payload);
                }
            }
            catch (err) {
                console.error(err);
            }
        }
    }
    catch (err) {
        console.error(err);
    }
};
exports.querySender = querySender;
const searchClickSender = async ({ user, device, logType, search_click_json, test, }) => {
    try {
        const { lat, lng } = (0, gpsStorageCtrl_1.getGpsCookie)();
        const getUserIp = sessionStorage.getItem("userIP");
        if (getUserIp) {
            exports.ip = getUserIp;
        }
        const payload = {
            Data: {
                log_type: test ? "search_click2" : logType,
                cookie_id: (0, logFn_1.getTotalCookieId)(cookieId),
                log_id: `${(0, uuid_random_1.default)()}-${(0, logFn_1.getRandomInt)(100000, 1000000)}`,
                ip: exports.ip,
                user_agent: userAgent,
                device: device,
                enter_date: (0, dateFormat_1.getFullTime)(),
                search_click_json: JSON.stringify(search_click_json),
                v_uid: (0, getUserVuid_1.default)(user),
                lat: lat,
                lng: lng,
            },
            PartitionKey: test ? "search_click2" : logType,
        };
        (0, fromLogSelector_1.fromSearchClickSelector)(payload);
        if (exports.ip) {
            try {
                await axios_1.default.put(logAPI, payload);
            }
            catch (err) {
                console.error(err);
            }
        }
        if (!exports.ip) {
            try {
                const ipString = await (0, getIp_1.getIPAwait)(exports.ip);
                if (ipString) {
                    payload.Data.ip = ipString;
                    sessionStorage.setItem("userIP", ipString);
                    await axios_1.default.put(logAPI, payload);
                }
            }
            catch (err) {
                console.error(err);
            }
        }
    }
    catch (err) {
        console.error(err);
    }
};
exports.searchClickSender = searchClickSender;
const regionKeywordClickSender = async ({ user, device, logType, region_keyword_click_json, test, }) => {
    try {
        const { lat, lng } = (0, gpsStorageCtrl_1.getGpsCookie)();
        const getUserIp = sessionStorage.getItem("userIP");
        if (getUserIp) {
            exports.ip = getUserIp;
        }
        const payload = {
            Data: {
                log_type: test ? "region_keyword_click" : logType,
                cookie_id: (0, logFn_1.getTotalCookieId)(cookieId),
                log_id: `${(0, uuid_random_1.default)()}-${(0, logFn_1.getRandomInt)(100000, 1000000)}`,
                ip: exports.ip,
                user_agent: userAgent,
                device: device,
                enter_date: (0, dateFormat_1.getFullTime)(),
                region_keyword_click_json: JSON.stringify(region_keyword_click_json),
                v_uid: (0, getUserVuid_1.default)(user),
                lat: lat,
                lng: lng,
            },
            PartitionKey: test ? "region_keyword_click" : logType,
        };
        // 이전 로그 정보 추가 
        const formerDataStr = localStorage.getItem("dclogformer");
        if (formerDataStr) {
            const formerData = JSON.parse(formerDataStr);
            payload.Data.from_log_id = formerData.log_id;
            payload.Data.from_log_type = formerData.log_type;
            payload.Data.from_enter_date = formerData.enter_date;
            if (formerData.query_json) {
                payload.Data.from_query_json = formerData.query_json;
            }
        }
        // 현재 로그 정보를 localStorage에 저장
        const payloadDataClone = { ...payload.Data };
        localStorage.setItem("dclogformer", JSON.stringify(payloadDataClone));
        if (exports.ip) {
            try {
                await axios_1.default.put(logAPI, payload);
            }
            catch (err) {
                console.error(err);
            }
        }
        if (!exports.ip) {
            try {
                const ipString = await (0, getIp_1.getIPAwait)(exports.ip);
                if (ipString) {
                    payload.Data.ip = ipString;
                    sessionStorage.setItem("userIP", ipString);
                    await axios_1.default.put(logAPI, payload);
                }
            }
            catch (err) {
                console.error(err);
            }
        }
    }
    catch (err) {
        console.error(err);
    }
};
exports.regionKeywordClickSender = regionKeywordClickSender;
const rkRelatedKeywordClickSender = async ({ user, device, logType, rk_related_keyword_click_json, test, }) => {
    try {
        const { lat, lng } = (0, gpsStorageCtrl_1.getGpsCookie)();
        const getUserIp = sessionStorage.getItem("userIP");
        if (getUserIp) {
            exports.ip = getUserIp;
        }
        const payload = {
            Data: {
                log_type: test ? "rk_related_keyword_click" : logType,
                cookie_id: (0, logFn_1.getTotalCookieId)(cookieId),
                log_id: `${(0, uuid_random_1.default)()}-${(0, logFn_1.getRandomInt)(100000, 1000000)}`,
                ip: exports.ip,
                user_agent: userAgent,
                device: device,
                enter_date: (0, dateFormat_1.getFullTime)(),
                rk_related_keyword_click_json: JSON.stringify(rk_related_keyword_click_json),
                v_uid: (0, getUserVuid_1.default)(user),
                lat: lat,
                lng: lng,
            },
            PartitionKey: test ? "rk_related_keyword_click" : logType,
        };
        // 이전 로그 정보 추가 
        const formerDataStr = localStorage.getItem("dclogformer");
        if (formerDataStr) {
            const formerData = JSON.parse(formerDataStr);
            payload.Data.from_log_id = formerData.log_id;
            payload.Data.from_log_type = formerData.log_type;
            payload.Data.from_enter_date = formerData.enter_date;
            if (formerData.query_json) {
                payload.Data.from_query_json = formerData.query_json;
            }
        }
        // 현재 로그 정보를 localStorage에 저장
        const payloadDataClone = { ...payload.Data };
        localStorage.setItem("dclogformer", JSON.stringify(payloadDataClone));
        if (exports.ip) {
            try {
                await axios_1.default.put(logAPI, payload);
            }
            catch (err) {
                console.error(err);
            }
        }
        if (!exports.ip) {
            try {
                const ipString = await (0, getIp_1.getIPAwait)(exports.ip);
                if (ipString) {
                    payload.Data.ip = ipString;
                    sessionStorage.setItem("userIP", ipString);
                    await axios_1.default.put(logAPI, payload);
                }
            }
            catch (err) {
                console.error(err);
            }
        }
    }
    catch (err) {
        console.error(err);
    }
};
exports.rkRelatedKeywordClickSender = rkRelatedKeywordClickSender;
const relatedKeywordClickSender = async ({ user, device, logType, related_keyword_click_json, test, }) => {
    try {
        const { lat, lng } = (0, gpsStorageCtrl_1.getGpsCookie)();
        const getUserIp = sessionStorage.getItem("userIP");
        if (getUserIp) {
            exports.ip = getUserIp;
        }
        const payload = {
            Data: {
                log_type: test ? "related_keyword_click" : logType,
                cookie_id: (0, logFn_1.getTotalCookieId)(cookieId),
                log_id: `${(0, uuid_random_1.default)()}-${(0, logFn_1.getRandomInt)(100000, 1000000)}`,
                ip: exports.ip,
                user_agent: userAgent,
                device: device,
                enter_date: (0, dateFormat_1.getFullTime)(),
                related_keyword_click_json: JSON.stringify(related_keyword_click_json),
                v_uid: (0, getUserVuid_1.default)(user),
                lat: lat,
                lng: lng,
            },
            PartitionKey: test ? "related_keyword_click" : logType,
        };
        // 이전 로그 정보 추가 
        const formerDataStr = localStorage.getItem("dclogformer");
        if (formerDataStr) {
            const formerData = JSON.parse(formerDataStr);
            payload.Data.from_log_id = formerData.log_id;
            payload.Data.from_log_type = formerData.log_type;
            payload.Data.from_enter_date = formerData.enter_date;
            if (formerData.query_json) {
                payload.Data.from_query_json = formerData.query_json;
            }
        }
        // 현재 로그 정보를 localStorage에 저장
        const payloadDataClone = { ...payload.Data };
        localStorage.setItem("dclogformer", JSON.stringify(payloadDataClone));
        if (exports.ip) {
            try {
                await axios_1.default.put(logAPI, payload);
            }
            catch (err) {
                console.error(err);
            }
        }
        if (!exports.ip) {
            try {
                const ipString = await (0, getIp_1.getIPAwait)(exports.ip);
                if (ipString) {
                    payload.Data.ip = ipString;
                    sessionStorage.setItem("userIP", ipString);
                    await axios_1.default.put(logAPI, payload);
                }
            }
            catch (err) {
                console.error(err);
            }
        }
    }
    catch (err) {
        console.error(err);
    }
};
exports.relatedKeywordClickSender = relatedKeywordClickSender;
const relatedRegionClickSender = async ({ user, device, logType, related_region_click_json, test, }) => {
    try {
        const { lat, lng } = (0, gpsStorageCtrl_1.getGpsCookie)();
        const getUserIp = sessionStorage.getItem("userIP");
        if (getUserIp) {
            exports.ip = getUserIp;
        }
        const payload = {
            Data: {
                log_type: test ? "related_region_click" : logType,
                cookie_id: (0, logFn_1.getTotalCookieId)(cookieId),
                log_id: `${(0, uuid_random_1.default)()}-${(0, logFn_1.getRandomInt)(100000, 1000000)}`,
                ip: exports.ip,
                user_agent: userAgent,
                device: device,
                enter_date: (0, dateFormat_1.getFullTime)(),
                related_region_click_json: JSON.stringify(related_region_click_json),
                v_uid: (0, getUserVuid_1.default)(user),
                lat: lat,
                lng: lng,
            },
            PartitionKey: test ? "related_region_click" : logType,
        };
        // 이전 로그 정보 추가 
        const formerDataStr = localStorage.getItem("dclogformer");
        if (formerDataStr) {
            const formerData = JSON.parse(formerDataStr);
            payload.Data.from_log_id = formerData.log_id;
            payload.Data.from_log_type = formerData.log_type;
            payload.Data.from_enter_date = formerData.enter_date;
            if (formerData.query_json) {
                payload.Data.from_query_json = formerData.query_json;
            }
        }
        // 현재 로그 정보를 localStorage에 저장
        const payloadDataClone = { ...payload.Data };
        localStorage.setItem("dclogformer", JSON.stringify(payloadDataClone));
        if (exports.ip) {
            try {
                await axios_1.default.put(logAPI, payload);
            }
            catch (err) {
                console.error(err);
            }
        }
        if (!exports.ip) {
            try {
                const ipString = await (0, getIp_1.getIPAwait)(exports.ip);
                if (ipString) {
                    payload.Data.ip = ipString;
                    sessionStorage.setItem("userIP", ipString);
                    await axios_1.default.put(logAPI, payload);
                }
            }
            catch (err) {
                console.error(err);
            }
        }
    }
    catch (err) {
        console.error(err);
    }
};
exports.relatedRegionClickSender = relatedRegionClickSender;
